__turbopack_context__.v({
  "animate": "popover-full-module-scss-module__WaOTmG__animate",
  "animate-enter": "popover-full-module-scss-module__WaOTmG__animate-enter",
  "animate-exit": "popover-full-module-scss-module__WaOTmG__animate-exit",
  "end": "popover-full-module-scss-module__WaOTmG__end",
  "header": "popover-full-module-scss-module__WaOTmG__header",
  "main": "popover-full-module-scss-module__WaOTmG__main",
  "popover-full": "popover-full-module-scss-module__WaOTmG__popover-full",
  "start": "popover-full-module-scss-module__WaOTmG__start",
  "title": "popover-full-module-scss-module__WaOTmG__title",
});
